import { type Language, SUPPORTED_LANGUAGES } from '@inflearn/i18n-tools';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import type { GetServerSidePropsContext } from 'next/types';

import PolicyLayout from '../../../components/layout/PolicyLayout';
import { PolicyContent } from '../../../components/pages/policy/PolicyContent';
import { HAS_GUIDE_LANG } from '../../../utils/i18n/hasGuideLang';

export const getStaticProps = async (context: GetServerSidePropsContext) => {
  const locale = context.locale as Language;
  const revalidateTime = 60;

  if (HAS_GUIDE_LANG.includes(locale)) {
    return {
      props: {
        ...(await serverSideTranslations(locale, ['common'])),
      },
      revalidate: revalidateTime,
    };
  }

  return {
    props: {
      ...(await serverSideTranslations(SUPPORTED_LANGUAGES.en, ['common'])),
    },
    revalidate: revalidateTime,
  };
};

export default function PolicyPreviousTermsOfServicePage() {
  const { t } = useTranslation();

  return (
    <PolicyLayout
      meta={{
        title: '메타.이전인프런이용약관.제목',
        description: '메타.이전인프런이용약관.설명',
      }}
    >
      <PolicyContent
        title={t('인프런 이용약관')}
        prevPolicy={{
          href: '/policy/terms-of-service',
          description: t('메타.이전인프런이용약관.설명'),
        }}
        type="TERMS"
        period="PREVIOUS"
      />
    </PolicyLayout>
  );
}
